import { render } from "./MenuListItemAdd.vue?vue&type=template&id=31c83105"
import script from "./MenuListItemAdd.vue?vue&type=script&lang=js"
export * from "./MenuListItemAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__